import { useMutation } from '@tanstack/react-query';

import { requestCode } from 'apps/customer/state/user';
import { getPhoneSendErrorMessage } from 'apps/customer/utils/phoneVerificationErrors';

import type { UseMutationOptions } from '@tanstack/react-query';
import type { PhoneVerificationSource } from 'apps/customer/utils/phoneVerificationHeap';

export type RequestVerifyCodeVariables = {
  hcaptchaToken?: string;
  isResend?: boolean;
  phoneNumber: string;
  source: PhoneVerificationSource;
};

export function useRequestVerifyCode(
  options?: UseMutationOptions<void, Error, RequestVerifyCodeVariables>,
) {
  return useMutation({
    mutationFn: async (variables: RequestVerifyCodeVariables) => {
      const response = await requestCode(variables);

      if (!response.success) {
        throw new Error(getPhoneSendErrorMessage(response.error));
      }
    },
    ...options,
  });
}
